import React from 'react';
import makeStyles from './styles';

const Divider = () => {
    const classes = makeStyles();
    return <div className={classes.dash} />;
};

export default Divider;
